import { render, staticRenderFns } from "./ListKanriHimmoku.vue?vue&type=template&id=283db9b4&"
import script from "./ListKanriHimmoku.vue?vue&type=script&lang=ts&"
export * from "./ListKanriHimmoku.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports